/* Manage the scroll by buttons in the channel list (city and area page) */
var InlinePropertyList = function(container) {
    var _this = this;
    _this.container = $(container);
    _this.propertiesContainer = $(container).find('.inline-property-list');

    _this.initialize();
}

InlinePropertyList.prototype = {
    constructor: InlinePropertyList,
    initialize: function (opt) {
        var _this = this;
        _this.propertiesContainer.find('.property-item:first-child').addClass('selected');
        
        if (_this.isDesktop()) {
            _this.refreshScroll();
        }

        $(window).resize(function() {
            if (_this.isDesktop()) {
                _this.refreshScroll();
            }
        });

        this.container.find('.slide-button-left').click(function(e) {
            _this.slideScroll(- _this.getNumberColumns());
        });
        
        this.container.find('.slide-button-right').click(function(e) {
            _this.slideScroll(_this.getNumberColumns());
        });
    },
    isDesktop: function () {
        return $(window).width() > 768;
    },
    getNumberColumns: function () {
        if ($(window).width() > 1200) {
            return 5;
        } else if ($(window).width() > 992) {
            return 4;
        } else if ($(window).width() > 768) {
            return 3;
        }
    },
    slideScroll: function (offset) {
        var selected =  this.propertiesContainer.find('.property-item.selected');
        
        var newIndex = selected.index() + offset;
        newIndex = Math.min(this.propertiesContainer.children().length - this.getNumberColumns(), newIndex);
        newIndex = Math.max(0, newIndex);
        
        selected.removeClass('selected');
        this.propertiesContainer.children().eq(newIndex).addClass('selected');
    
        this.refreshScroll();
    },
    refreshScroll: function () {
        var selectedOffset = this.propertiesContainer.find('.property-item.selected').offset().left + this.propertiesContainer.scrollLeft() - this.propertiesContainer.offset().left;
        this.propertiesContainer.scrollLeft(selectedOffset);
    
        var selectedIndex = this.propertiesContainer.find('.property-item.selected').index();
        this.container.find('.slide-button-left').css('visibility', selectedIndex == 0 ? 'hidden' : 'visible');
        this.container.find('.slide-button-right').css('visibility', selectedIndex >= this.propertiesContainer.children().length - this.getNumberColumns() ? 'hidden' : 'visible');
    }
};

$.fn.inlinePropertyList = function () {
    var inlinePropertyList = new InlinePropertyList($(this));
    $(this).data('inlinePropertyList', inlinePropertyList);
    return inlinePropertyList;
}

$(function() {
    $('.inline-property-list-container').each(function() {
        $(this).inlinePropertyList();
    })
})